import {
  Button,
  Drawer,
  DrawerBody,
  DrawerBodyProps,
  DrawerContent,
  DrawerContentProps,
  DrawerFooter,
  DrawerFooterProps,
  DrawerHeader,
  DrawerHeaderProps,
  DrawerProps,
} from "@heroui/react";
import { X } from "lucide-react";
import React from "react";

export const LimeDrawer = ({
  drawerProps,
  contentProps,
  headerProps,
  bodyProps,
  footerProps,

  header,
  footer,
  body,
}: {
  drawerProps?: Omit<DrawerProps, "children"> & {
    dataIdentifier?: string;
  };
  contentProps?: DrawerContentProps;
  headerProps?: DrawerHeaderProps;
  bodyProps?: DrawerBodyProps;
  footerProps?: DrawerFooterProps;

  /**
   * @description Try not to use the default header unless really necessary!
   */
  header?:
    | {
        useDefaultHeader?: false;
        closeButtonRowContent?: React.ReactNode;
        content?: React.ReactNode;
      }
    | {
        useDefaultHeader: true;
        content: React.ReactNode;
      };
  footer?: { content: React.ReactNode };
  body: { content: React.ReactNode };
}) => {
  const headerContent = (onClose: () => void) => {
    if (header?.useDefaultHeader) {
      return header.content;
    }

    return (
      <div className="flex w-full flex-col">
        <div className="flex w-full items-center justify-between">
          {header?.closeButtonRowContent}

          <Button
            isIconOnly
            onPress={onClose}
            size="sm"
            variant="light"
            data-identifier="close-appointment-modal-button"
          >
            <X size={16} />
          </Button>
        </div>

        {header?.content}
      </div>
    );
  };

  return (
    <Drawer
      {...drawerProps}
      data-identifier={drawerProps?.dataIdentifier}
      hideCloseButton={!header?.useDefaultHeader}
    >
      <DrawerContent {...contentProps}>
        {(onClose) => (
          <>
            <DrawerHeader {...headerProps}>
              {headerContent(onClose)}
            </DrawerHeader>
            <DrawerBody {...bodyProps}>{body.content}</DrawerBody>
            <DrawerFooter {...footerProps}>{footer?.content}</DrawerFooter>
          </>
        )}
      </DrawerContent>
    </Drawer>
  );
};
